
<span id="provider-tables-wrapper">
  <span id="left-table-wrapper" class="table-wrapper">
    <div id="available-provider-table-title" class="table-title">Providers</div>
    <span id="department-specialty-wrapper">
      <app-search-department [departments]="listOfAllDepartments"
                             [showSpecialties]="showSpecialties" (afterDepartmentsUpdated)="whenDepartmentsUpdated($event)"
                             [whenToggled]="whenDepartmentsToggled">
      </app-search-department>
      <app-search-specialty [specialties]="listOfAllSpecialties"
                            [showDepartments]="showDepartments" (afterSpecialtiesUpdated)="whenSpecialtiesUpdated($event)"
                            [whenToggled]="whenSpecialtiesToggled">
      </app-search-specialty>
      <span class="input-search-wrapper">
        <input type="text" placeholder="Provider Search..." id="search-for"
           (input)="onSearchTextChanged()" [(ngModel)]="searchText">
          <i *ngIf="searchText.length" id="cross" class="fa fa-times cross-button" aria-hidden="true"
             (click)="clearSearch()"></i>
          <i *ngIf="!searchText" id="search-glass" class="fa fa-search search-icon" aria-hidden="true"
             [matTooltip]="'3 letters required'" [matTooltipPosition]="'above'"
             [matTooltipDisabled]="searchText.length >= 3" [matTooltipClass]="'custom-tooltip'"></i>
      </span>
    </span>
    <div class="provider-header-wrapper">
      <div id="available-providers-header">
        <span (click)="handleSortChange(columnsAvailableProviders[0].columnDef, 0)" class="column-header">
          <mat-checkbox (click)="selectAllProviders($event)" class="header-check" id="select-all"></mat-checkbox>
          {{columnsAvailableProviders[0].header}}
          <i class="fa fa-arrow-up" *ngIf="sortDirectionAvailableProviders==='asc' &&
           sortColumnAvailableProviders===columnsAvailableProviders[0].columnDef"></i>
          <i class="fa fa-arrow-down" *ngIf="sortDirectionAvailableProviders==='desc' &&
           sortColumnAvailableProviders===columnsAvailableProviders[0].columnDef"></i>
        </span>
        <span *ngFor="let column of columnsAvailableProviders.slice(1)" (click)="handleSortChange(column.columnDef,
         0)" class="column-header{{column.header}}">{{column.header}}
          <i class="fa fa-arrow-up" *ngIf="sortDirectionAvailableProviders==='asc' && sortColumnAvailableProviders===column.columnDef"></i>
          <i class="fa fa-arrow-down" *ngIf="sortDirectionAvailableProviders==='desc' && sortColumnAvailableProviders===column.columnDef"></i>
        </span>
      </div>
    </div>
    <span *ngIf="!availableProviders.length" id="available-providers-emptiness-indicator">Select a Department/Specialty to view providers</span>
    <mat-table [dataSource]="dataSourceAvailableProviders" (scroll)="handleScrollAvailableProviders($event)">
      <ng-container *ngFor="let column of columnsAvailableProviders; let y = index" [matColumnDef]="column.header">
        <mat-cell *matCellDef="let row">
          <mat-checkbox *ngIf="!y" [checked]="false">
            <span class="rest-of-provider-name">{{column.dataName(row, searchText)[0]}}</span>
            <span class="provider-is-searched-by">{{column.dataName(row, searchText)[1]}}</span>
            <span class="rest-of-provider-name">{{column.dataName(row, searchText)[2]}}</span>
          </mat-checkbox>
          <span *ngIf="y">{{column.dataName(row)}}</span>
        </mat-cell>
      </ng-container>
      <mat-row *matRowDef="let row; columns: displayedColumnsAvailableProviders" (click)="whenProviderSelected(row)"></mat-row>
    </mat-table>
  </span>
  <span id="right-table-wrapper" class="table-wrapper">
    <div id="right-table-heading">
      <div class="table-title">Selected Providers<i class="fa fa-info-circle" (mouseleave)="showProviderGuidelines=false"
                                                    (mouseenter)="showProviderGuidelines = true">
        <div id="provider-guidelines" *ngIf="showProviderGuidelines">
          <div id="guidelines-header">You can make either of the following selections:</div>
          <div id="guidelines-list">
            <div>- Up to 120 entire departments or specialties</div>
            <div>- Or, a customized list of up to 120 individual providers</div>
          </div>
          <div id="guidelines-footer">If your list exceeds 120, please adjust your selected providers list to continue</div>
        </div>
      </i></div>
    </div>
    <div class="provider-header-wrapper">
      <div id="selected-providers-header">
        <span (click)="handleSortChange(columnsSelectedProviders[0].columnDef, 1)" class="column-header">
          <mat-checkbox (click)="deselectAllProviders($event)" class="header-check" id="deselect-all"
                        [checked]="selectedProviders.length >= 1"></mat-checkbox>
          {{columnsSelectedProviders[0].header}}
          <i class="fa fa-arrow-up" *ngIf="sortDirectionSelectedProviders==='asc' &&
           sortColumnSelectedProviders===columnsSelectedProviders[0].columnDef"></i>
          <i class="fa fa-arrow-down" *ngIf="sortDirectionSelectedProviders==='desc' &&
           sortColumnSelectedProviders===columnsSelectedProviders[0].columnDef"></i>
        </span>
        <span *ngFor="let column of columnsSelectedProviders.slice(1)" (click)="handleSortChange(column.columnDef,
         1)" class="column-header{{column.header}}">{{column.header}}
          <i class="fa fa-arrow-up" *ngIf="sortDirectionSelectedProviders==='asc' && sortColumnSelectedProviders===column.columnDef"></i>
          <i class="fa fa-arrow-down" *ngIf="sortDirectionSelectedProviders==='desc' && sortColumnSelectedProviders===column.columnDef"></i>
        </span>
      </div>
    </div>
    <mat-table [dataSource]="dataSourceSelectedProviders" (scroll)="handleScrollSelectedProviders($event)">
      <ng-container *ngFor="let column of columnsSelectedProviders; let y = index" [matColumnDef]="column.header">
        <mat-cell *matCellDef="let row" id="{{column.columnDef}}a">
          <mat-checkbox *ngIf="!y" [checked]="true">{{column.dataName(row)}}</mat-checkbox>
          <span *ngIf="y">{{column.dataName(row)}}</span>
        </mat-cell>
      </ng-container>
      <mat-row *matRowDef="let row; columns: displayedColumnsSelectedProviders" (click)="whenProviderDeselected(row)"></mat-row>
    </mat-table>
  </span>
</span>
